import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Row } from 'reactstrap';
import { toast } from 'react-toastify';

import { useDispatch } from 'react-redux';
import { handleObject } from '../../store/action/configurationsChat/loadConfigChat';

import Service from './service/index';

import { Form } from './style';

import { ClosingFields } from './modules/closingFields/index';
import { Timeout } from './modules/timeout/index';
import { TimeEndConversation } from './modules/timeEndConversation';
import ReactLoader from 'components/Loader';
import SimpleHeader from '../../components/Headers/SimpleHeader';
import { SimultaneousChatsLimit } from './modules/simultaneousChats';
import { RedistributionStrategy } from './modules/redistributionStrategy';

const ConfigurationsSystem = () => {
  const [loading, setLoading] = useState(true);
  const [control5, setControl5] = useState(false);
  const [control6, setControl6] = useState(false);
  const [control7, setControl7] = useState(false);
  const [control9, setControl9] = useState(false);
  const [control10, setControl10] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    Service.getAll()
      .then((response) => {
        setLoading(false);
        dispatch(handleObject(response.data));
      })
      .catch((error) => {
        if (error.response) {
          toast.error('Erro ao carregar usuários!', {
            autoClose: 3000,
            closeOnClick: true
          });
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function controledPanel5(boll) {
    setControl5(boll);
  }
  function controledPanel6(boll) {
    setControl6(boll);
  }

  function controledPanel7(boll) {
    setControl7(boll);
  }

  function controledPanel9(boll) {
    setControl9(boll);
  }

  function controledPanel10(boll) {
    setControl10(boll);
  }

  return (
    <>
      <SimpleHeader />
      {loading ? (
        <div className="py-4 responsive">
          <Row className="justify-content-md-center">
            <ReactLoader />
          </Row>
        </div>
      ) : (
        <Form>
          <Accordion
            className="accodionEnd"
            expanded={control5}
            onChange={() => setControl5(!control5)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel6a-content"
              id="panel6a-header"
            >
              <strong>Campos de encerramento</strong>
            </AccordionSummary>
            <AccordionDetails>
              <ClosingFields controledPanel5={controledPanel5} />
            </AccordionDetails>
          </Accordion>

          <Accordion
            className="accodionEnd"
            expanded={control6}
            onChange={() => setControl6(!control6)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel6a-content"
              id="panel6a-header"
            >
              <strong>Inatividade</strong>
            </AccordionSummary>
            <AccordionDetails>
              <Timeout controledPanel6={controledPanel6} />
            </AccordionDetails>
          </Accordion>

          <Accordion
            className="accodionEnd"
            expanded={control7}
            onChange={() => setControl7(!control7)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel7a-content"
              id="panel7a-header"
            >
              <strong>Tempo de encerramento de conversa</strong>
            </AccordionSummary>

            <AccordionDetails>
              <TimeEndConversation controledPanel7={controledPanel7} />
            </AccordionDetails>
          </Accordion>

          <Accordion
            className="accodionEnd"
            expanded={control9}
            onChange={() => setControl9(!control9)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel9a-content"
              id="panel9a-header"
            >
              <strong>Limite de resgates simultâneos</strong>
            </AccordionSummary>

            <AccordionDetails>
              <SimultaneousChatsLimit controledPanel9={controledPanel9} />
            </AccordionDetails>
          </Accordion>

          <Accordion
            className="accodionEnd"
            expanded={control10}
            onChange={() => setControl10(!control10)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel10a-content"
              id="panel10a-header"
            >
              <strong>
                Estratégia de redistribuição após login em filas de chat
              </strong>
            </AccordionSummary>

            <AccordionDetails>
              <RedistributionStrategy controledPanel10={controledPanel10} />
            </AccordionDetails>
          </Accordion>
        </Form>
      )}
    </>
  );
};

export default ConfigurationsSystem;
